// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kz-0";
export var fileList = "_kz-2";
export var removeFileButton = "_kz-1";